export const isTodayWeekToEaster = () => {
    const today = new Date();
    const year = today.getFullYear();

    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f1 = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f1 + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;

    const easterDate = new Date(year, month - 1, day); // JS months are 0-based
    const weekBeforeEaster = new Date(easterDate);
    weekBeforeEaster.setDate(easterDate.getDate() - 7);

    return (
        today.getFullYear() === weekBeforeEaster.getFullYear() &&
        today.getMonth() === weekBeforeEaster.getMonth() &&
        today.getDate() === weekBeforeEaster.getDate()
    );
};

export const changeDateFormat = (timestamp, separator) => {
    const separatorValue = separator || '.';
    const date = new Date(timestamp);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // add 1 to month as it starts from 0
    const year = date.getFullYear();
    if (day && month && year) {
        const formattedDate = `${day}${separatorValue}${month}${separatorValue}${year}`;
        return formattedDate;
    } else {
        return null;
    }
};

export const epochToDateString = (timestamp, inverted) => {
  const date = new Date(timestamp);

  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();

  if (inverted) {
    return `${yyyy}-${mm}-${dd}`;
  }

  return `${dd}-${mm}-${yyyy}`;
}